"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BibFile_1 = require("./BibFile");
var bibtex_1 = require("bibtex");
var TexTranslator = (function (_super) {
    __extends(TexTranslator, _super);
    function TexTranslator() {
        var _this = _super.call(this) || this;
        _this.state = {
            tex: "@Book{abramowitz+stegun,\n author    = \"Milton {Abramowitz} and Irene A. {Stegun}\",\n title     = \"Handbook of Mathematical Functions with\n              Formulas, Graphs, and Mathematical Tables\",\n publisher = \"Dover\",\n year      =  1964,\n address   = \"New York City\",\n edition   = \"ninth Dover printing, tenth GPO printing\"\n}\n\n@proceedings{bex2016legal,\n  title={Legal Knowledge and Information Systems: JURIX 2016: The Twenty-Ninth Annual Conference},\n  author={Bex, Floris and Villata, Serena},\n  volume={294},\n  year={2016},\n  publisher={IOS Press}\n}\n\n@INPROCEEDINGS{trompper2016automatic,\n    title={Automatic Assignment of Section Structure to Texts of Dutch Court Judgments},\n  author={Trompper, Maarten and Winkels, Raboud},\n  pages = {167-172},\n  crossref = {bex2016legal}\n}\n",
        };
        return _this;
    }
    TexTranslator.prototype.onChangeInput = function (tex) {
        this.setState({
            tex: tex,
        });
    };
    TexTranslator.prototype.render = function () {
        var _this = this;
        return React.createElement("div", { className: "demo" },
            React.createElement("div", { className: "input-field-tex" },
                React.createElement("h2", null, "BibTeX source"),
                React.createElement("div", { className: "mdc-textfield mdc-textfield--multiline" },
                    React.createElement("textarea", { className: "mdc-textfield__input input", name: "tex-input", rows: 8, value: this.state.tex, onChange: function (e) { return _this.onChangeInput(e.target.value); }, id: "tex-input", placeholder: "Input LaTeX / TeX here" }))),
            React.createElement("div", { className: "output" }, getParsedTex(this.state.tex)));
    };
    return TexTranslator;
}(React.PureComponent));
exports.TexTranslator = TexTranslator;
function getParsedTex(tex) {
    try {
        var result = bibtex_1.parseBibFile(tex);
        return React.createElement(BibFile_1.BibFileComponent, { bib: result });
    }
    catch (e) {
        return React.createElement("div", { className: "error" }, "ERROR: " + e.message);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/ts/components/TexTranslator.tsx
// module id = 78
// module chunks = 0